import clsx from 'clsx';
import {useEffect, useRef, useState} from 'react';
import Icon from '../Icon';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { translate } from '../../Services/translation';

interface ProductPageLinkBlockProps {
  url?: string;
  onClick?: () => void;
  buttonText: string;
  iconName?: string;
  preTitle?: string;
  title?: string;
  description?: string;
  className?: string;
  productId?: string;
  openInNewWindow?: boolean;
  displayArButton?: boolean;
}

interface MutationCallback {
  (mutations: MutationRecord[], observer: MutationObserver): void;
}

const ProductPageLinkBlock = ({
  url,
  buttonText,
  iconName,
  preTitle,
  title,
  description,
  className,
  productId,
  openInNewWindow = false,
  displayArButton = false,
  displayButton = true,
  onClick,
}: ProductPageLinkBlockProps) => {

  const mutationRef = useRef(null);
  const [containerDisplay, setContainerDisplay] = useState('none');
  const onMutation: MutationCallback = (mutations, observer) => {
      for (const mutation of mutations) {
          if (mutation.oldValue == 'visibility:hidden' && mutation.target.style.visibility == 'visible') {
              setContainerDisplay('block');
          }
      }
  }
  if(displayArButton) {
        useMutationObserver(mutationRef, onMutation);
  }

  useEffect(() => {
      if (mutationRef.current != null && mutationRef.current.style.visibility == 'hidden') {
          setContainerDisplay('none');
      } 
      else {
          setContainerDisplay('block')
      }
  }, [mutationRef.current]);

  return (
    <div
        className={clsx('rounded bg-gray-100 p-6 lg:p-8', className)}
        {...(displayArButton && { style: { display: containerDisplay } })}
    >
      {preTitle && (
        <div className="pretitle-sm mb-3 inline-block">{preTitle}</div>
      )}
      {title && <h3 className="mb-2">{title}</h3>}
      {description && <div>{description}</div>}
      <div
        className={clsx(
          'flex flex-wrap gap-4 mt-6',
          displayArButton && 'roomvo-container'
        )}
        data-product-type-str="wall"
      >
        {displayButton &&
          (url ? (
            <a
              href={url}
              className="btn btn--black btn--large"
              target={openInNewWindow ? '_blank' : undefined}
              rel="noreferrer"
              onClick={onClick}
            >
              {iconName && (
                <Icon name={iconName} className="mr-3 h-6 w-6" />
              )}
              {buttonText}
            </a>
          ) : (
            <button
              className="btn btn--black btn--large"
              onClick={onClick}
            >
              {iconName && (
                <Icon name={iconName} className="mr-3 h-6 w-6" />
              )}
              {buttonText}
            </button>
          ))}
        {displayArButton && productId && (
          <button
            className="roomvo-stimr btn btn--black btn--large"
            data-sku={productId}
            onClick={onClick}
            ref={mutationRef}
            style={{ visibility: 'hidden' }}
          >
            {iconName && <Icon name={iconName} className="mr-3 h-6 w-6" />}
            {translate('product-page.wallpaper-roomvo.button')}
          </button>
        )}
      </div>
    </div>
  );
};

const useMutationObserver = (
    ref,
    callback,
    options = {
      characterData: true,
      childList: true,
      subtree: true,
      attributes: true,
      attributeOldValue: true,
      characterDataOldValue: true,
      attributeFilter: ['style'],
    }
) => {
  useEffect(() => {
    const observer = new MutationObserver(callback);
    observer.observe(ref.current, options);
    return () => observer.disconnect();
  }, [ref]);
}
export default ProductPageLinkBlock;
